var REGION = ''; //starting state
var ECOSYSTEM = ''; //starting site
var LOCATION = ''; //starting site location

function getParameterByName(name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));        
}

//if the region is defined
if ( getParameterByName("region") ) {

    //if the ecosystem is defined
    if ( getParameterByName("ecosystem") ) {

        // checking if there is a parameter in the URL / add one if not
        if ( getParameterByName("location") ) {

            console.log('starting location set to: ' + getParameterByName("location"));
            setTimeout(function () {

                var targetEl = document.querySelector('a-videosphere');
                var newLocation = getParameterByName("location");
                var newLocationID = "#"+newLocation;
                var video = document.getElementById(newLocation);
                var offsetY = video.getAttribute("offset-y");

                navigate(newLocationID);

                targetEl.setAttribute('material', 'src', newLocationID);
                targetEl.setAttribute('rotation', 'y', offsetY);
                targetEl.emit('fade-video-in');
            }, 300);

        } else {
            
            //queryString.push('location', LOCATION); // query-string library
            console.log('starting location init: ' + getParameterByName("location"));

        }


    }else {
        //queryString.push('ecosystem', ECOSYSTEM); // query-string library
    }

}else {
    //queryString.push('region', REGION); // query-string library
}



//////////////////
// WEBPACK FOOTER
// ./src/navigate.js
// module id = 9
// module chunks = 0